export default __webpack_public_path__ + "static/media/2303.f161e3ad.png";